import { ImageLibComponent } from './components/image-lib/image-lib.component';
import { EwMaImageService } from './ew-ma-image.service';
import { EwTranslateService } from './services/ew-translate.service';
import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoggerService } from 'ew-common-lib';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'lib-ew-ma-image',
  templateUrl: './ew-ma-image.component.html',
  styles: [],
})
export class EwMaImageComponent implements OnInit, OnChanges {
  /**
   * @description
   * Event id from parent component.
   */
  @Input() event_id: string = '';
  @Input() unsplash: boolean = true;
  @Input() showImageLibPopup: boolean = false;
  @Input() label_text: string = 'Offer Image';
  @Input() default_language: string = 'en';
  @Input() img_width: string = '340';
  @Input() img_height: string = '370';
  @Input() env = {};

  @Input() showImageLibraryPopup:Boolean = false;

  /**
   * @description
   * Emit event to close dialog.
   */
  @Output() selectedImage: EventEmitter<any> = new EventEmitter();

  constructor(
    private ewTranslateService: EwTranslateService,
    public translate: TranslateService,
    private ewloggerService: LoggerService,
    private ewMaImageService: EwMaImageService,
    public dialog: MatDialog
  ) {
    this.ewloggerService.initLogger();
    translate.addLangs(['en', 'es']);
  }

  /**
   * @description
   * Set event id in service for use in library.
   */
  ngOnInit(): void {
    this.ewMaImageService.eventId = this.event_id;
    this.ewMaImageService.env = this.env;
    this.initLanguage();
  }

  initLanguage() {
    this.translate.setDefaultLang(this.default_language);
    this.translate.use(this.default_language).subscribe(() => {
      this.ewTranslateService.init();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.default_language) {
      this.default_language = changes.default_language.currentValue;
      this.initLanguage();
    }
    if (changes.showImageLibPopup && changes.showImageLibPopup.currentValue) {
      this.imageGallary();
    }
  }

  imageGallary(): void {
    const dialogRef = this.dialog.open(ImageLibComponent, {
      maxWidth: '950px',
      width: '100%',
      panelClass: 'image-gallary',
      data: {
        showUnsplash: this.unsplash,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {      
      this.selectedImage.emit(result);
    });
  }
}
